<template lang="pug">
 v-row
    v-col(cols=12)
      h2 Курирование
      p Консультирование по организационным вопросам
    v-col(cols=12 md=8)
      actions-list(
        :init="loading.actionsLoading"
        :actions="actions"
      )
      template(v-if="!actions.length && !loading.actionsLoading")
        p Консультаций не найдено...
    v-col(cols=12 md=4)
      actions-filters(
        key="supevision"
        course-only
        @input="fetchActions"
      )
</template>

<script>
import { SUBJECT_TYPES } from '../constants';

import ActionsList from '../components/StudentActionsList.vue';
import ActionsFilters from '../components/CourseUnitsFilters.vue';

export default {
  components: {
    ActionsList,
    ActionsFilters,
  },
  data: () => ({
    actions: [],
    myGroups: [],
    loading: {
      actionsLoading: true,
    },
  }),
  methods: {
    async fetchGroups() {
      const response = await this.$api.groups.getGroupList({
        // Получить все мои группы, где я преподаю
        'search[my_self]': 1,
      });
      this.myGroups = response.data.data;
    },
    async fetchActions(tags) {
      this.loading.actionsLoading = true;

      if (!this.myGroups.length) await this.fetchGroups();

      const { items: consultations } = await this.$api.chat.getConsultations(
        {
          group_id: this.myGroups.map((i) => i.id),
          tags,
        },
      );
      this.actions = consultations
        .filter(
          (i) => i.subjectType === SUBJECT_TYPES.course,
        )
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      this.loading.actionsLoading = false;
    },
  },
};
</script>
